import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h3", null, "休日設定", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("平日の祝日を自動的に休日にする")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("土曜日のの祝日を自動的に休日にする")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("日曜日の祝日を自動的に休日にする")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("振替休日の祝日を自動的に休日にする")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_toggle_switch = _resolveComponent("toggle-switch")
  const _component_vue_content_item_frame = _resolveComponent("vue-content-item-frame")

  return (_openBlock(), _createBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_vue_content_item_frame, null, {
      default: _withCtx(() => [
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.holidayAutoClose,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.holidayAutoClose = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.holidayAutoCloseSat,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.holidayAutoCloseSat = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.holidayAutoCloseSun,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.holidayAutoCloseSun = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_toggle_switch, {
          modelValue: _ctx.holidayAutoCloseSub,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.holidayAutoCloseSub = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ]))
}